<template>
    <svg
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.222 19.776a4.984 4.984 0 0 0 3.535 1.462 4.987 4.987 0 0 0 3.536-1.462l2.828-2.83-1.414-1.413-2.828 2.829a3.007 3.007 0 0 1-4.243 0 3.005 3.005 0 0 1 0-4.243l2.829-2.828L7.05 9.877l-2.83 2.828a5.006 5.006 0 0 0 0 7.07Zm15.556-8.485a5.008 5.008 0 0 0 0-7.071 5.006 5.006 0 0 0-7.071 0L9.879 7.049l1.414 1.414 2.828-2.83a3.007 3.007 0 0 1 4.243 0 3.005 3.005 0 0 1 0 4.244l-2.83 2.828 1.415 1.414 2.829-2.828Z"
        ></path>
        <path
            d="m8.464 16.947-1.415-1.414 8.487-8.486 1.414 1.415-8.486 8.485Z"
        ></path>
    </svg>
</template>
